export type SolverObjectiveRankingModelOrderedCriteriaItem =
    (typeof SolverObjectiveRankingModelOrderedCriteriaItem)[keyof typeof SolverObjectiveRankingModelOrderedCriteriaItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SolverObjectiveRankingModelOrderedCriteriaItem = {
    MaximizePlacedArea: 'MaximizePlacedArea',
    MinimizeCost: 'MinimizeCost',
    MinimizeArticleCount: 'MinimizeArticleCount',
    MinimizeDistinctArticleTypes: 'MinimizeDistinctArticleTypes',
    MinimizeGapWidth: 'MinimizeGapWidth'
} as const;
